import Model from '@/lib/data/Model';

class Organization extends Model {
    fields = [
        'id',
        'name',
        'title',
        'code',
        'parent_id',
        'max_meeting_time',
        'max_record_time',
        'max_monthly_meeting',
        'max_disk_size_per_user',
        'max_org_user',
        'max_monthly_survey_per_user',
        'allow_multiple_conversation',
        'max_client',
        {
            name: 'is_micro',
            default: false,
        },
        {
            name: 'is_owner',
            default: false,
        },
        {
            name: 'children',
            association: {
                type: 'many',
                model: Organization,
            },
        },
        'call_restrictions',
        'org_tag',
        {
            name: 'mfa_enabled',
            default: false,
        },
        {
            name: 'features',
            defaultValue: { claim_management: false },
        },
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'read',
            url: '/organization/list',
            method: 'GET',
        },
        {
            name: 'save',
            url: '/organization/save',
            method: 'POST',
            params: [
                'id',
                'parent_id',
                'name',
                'title',
                'is_micro',
                'max_monthly_meeting',
                'max_meeting_time',
                'max_record_time',
                'max_disk_size_per_user',
                'max_org_user',
                'max_monthly_survey_per_user',
                'org_tag',
                'max_client',
                'mfa_enabled',
            ],
        },
        {
            name: 'delete',
            url: '/organization/delete',
            params: ['id'],
        },
        {
            name: 'saveCallRestriction',
            url: '/organization/saveCallRestriction',
            method: 'POST',
            params: [
                'call_restriction',
                // 'id',
                // 'call_type',
                // // 'max_screenshot_count',
                // 'max_meeting_time',
                // 'max_record_time',
                // 'max_monthly_meeting',
                // // 'allow_multiple_conversation',
                // 'organization_id',
                // 'max_monthly_meeting_per_user'
            ],
        },
        {
            name: 'deleteCallRestriction',
            method: 'DELETE',
            url: '/organization/deleteCallRestriction',
            params: ['call_restriction'],
        },
        {
            name: 'deleteAccountRequest',
            url: '/organization/delete_account_request',
            params: ['id'],
        },
    ];
}

export default Organization;
